import React, { useState } from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { useRouter } from 'next/router'
import * as S from './SectionSolucaoBioAtlas.styles'
import ImageNext from '@/components/ImageNext'

const ArrowRightIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 12H19"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 5L19 12L12 19"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const SectionSolucaoBioAtlas = () => {
  const { t } = useTranslation()
  const router = useRouter()
  const [hoverProf, setHoverProf] = useState(false)
  const [hoverAluno, setHoverAluno] = useState(false)

  const professoresList = t(
    'landingV2.sectionSolucaoBioAtlas.professores.list',
    { returnObjects: true }
  ) as string[]
  const alunosList = t('landingV2.sectionSolucaoBioAtlas.alunos.list', {
    returnObjects: true
  }) as string[]

  return (
    <S.Section>
      <S.Title>
        <Trans i18nKey="landingV2.sectionSolucaoBioAtlas.title" />
      </S.Title>
      <S.Row>
        <S.ImgCol>
          <S.ImageWrapper
            $hovered={hoverProf}
            onMouseEnter={() => setHoverProf(true)}
            onMouseLeave={() => setHoverProf(false)}
          >
            <S.StaticContent>
              <S.StaticTitle>
                {t('landingV2.sectionSolucaoBioAtlas.professores.staticTitle')}
              </S.StaticTitle>
              <S.StaticSubtitle>
                {t(
                  'landingV2.sectionSolucaoBioAtlas.professores.staticSubtitle'
                )}
              </S.StaticSubtitle>
            </S.StaticContent>
            <S.ImageOverlay>
              <S.OverlayContent>
                <S.OverlayTitle>
                  {t('landingV2.sectionSolucaoBioAtlas.professores.title')}
                </S.OverlayTitle>
                <S.OverlayList>
                  {Array.isArray(professoresList) &&
                    professoresList.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                </S.OverlayList>
                <S.OverlayButton onClick={() => router.push('/ForTeachers')}>
                  {t('landingV2.sectionSolucaoBioAtlas.professores.button')}{' '}
                  <ArrowRightIcon />
                </S.OverlayButton>
              </S.OverlayContent>
            </S.ImageOverlay>
            <ImageNext
              src={
                hoverProf
                  ? '/assets/images/solucao_professor_hover.png'
                  : `${process.env.CDN_URL}/public/landingpagev2/defaults/solucao_professor.png`
              }
              alt={t('landingV2.sectionSolucaoBioAtlas.altProfessores')}
              width={603}
              height={414}
              style={{
                maxWidth: '100%',
                height: 'auto',
                width: 'revert-layer',
                borderRadius: 50
              }}
              priority
            />
          </S.ImageWrapper>
        </S.ImgCol>
        <S.ImgCol>
          <S.ImageWrapper
            $hovered={hoverAluno}
            onMouseEnter={() => setHoverAluno(true)}
            onMouseLeave={() => setHoverAluno(false)}
          >
            <S.StaticContent>
              <S.StaticTitle>
                {t('landingV2.sectionSolucaoBioAtlas.alunos.staticTitle')}
              </S.StaticTitle>
              <S.StaticSubtitle>
                {t('landingV2.sectionSolucaoBioAtlas.alunos.staticSubtitle')}
              </S.StaticSubtitle>
            </S.StaticContent>
            <S.ImageOverlay>
              <S.OverlayContent>
                <S.OverlayTitle>
                  {t('landingV2.sectionSolucaoBioAtlas.alunos.title')}
                </S.OverlayTitle>
                <S.OverlayList>
                  {Array.isArray(alunosList) &&
                    alunosList.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                </S.OverlayList>
                <S.OverlayButton onClick={() => router.push('/ForStudents')}>
                  {t('landingV2.sectionSolucaoBioAtlas.alunos.button')}{' '}
                  <ArrowRightIcon />
                </S.OverlayButton>
              </S.OverlayContent>
            </S.ImageOverlay>
            <ImageNext
              src={
                hoverAluno
                  ? '/assets/images/solucao_alunos_hover.png'
                  : `${process.env.CDN_URL}/public/landingpagev2/defaults/solucao_aluno.png`
              }
              alt={t('landingV2.sectionSolucaoBioAtlas.altAlunos')}
              width={603}
              height={414}
              style={{
                maxWidth: '100%',
                height: 'auto',
                width: 'revert-layer',
                borderRadius: 50
              }}
              priority
            />
          </S.ImageWrapper>
        </S.ImgCol>
      </S.Row>
    </S.Section>
  )
}

export default SectionSolucaoBioAtlas
